<div class="fgbcl-badge-count d-flex">
  <div class="fgbcl-badges-stat">
    <h3 class="fgbcl-badges-stat-value mb-0">{{ completed$ | async }}</h3>
    <p class="fgbcl-badges-stat-label mb-0">{{ 'fgbcl.badge.count.completed' | translate }}</p>
  </div>
  <div class="fgbcl-badges-stat">
    <h3 class="fgbcl-badges-stat-value mb-0">{{ inProgress$ | async }}</h3>
    <p class="fgbcl-badges-stat-label mb-0">{{ 'fgbcl.badge.count.progress' | translate }}</p>
  </div>
  <div class="fgbcl-badges-stat">
    <h3 class="fgbcl-badges-stat-value mb-0">{{ locked$ | async }}</h3>
    <p class="fgbcl-badges-stat-label mb-0">{{ 'fgbcl.badge.count.locked' | translate }}</p>
  </div>
</div>

<div class="fgbcl-scorecard-badges" *ngIf="badgesByCategory$ | async as categories">
  <!-- Empty state, same markup as the page's challenges placeholder; shown only once the store has loaded -->
  <div class="challenges-placeholder mb-3" role="status" *ngIf="isLoaded() && categories.length === 0">
    <div class="no-items m-0 no-results-placeholder-div">
      <div class="svg ms-auto me-auto" fgbAnimateSvg>
        <img [src]="'placeholders/badges.svg' | contentAssetImage" alt="" />
      </div>
      <div class="no-results-placeholder">{{ 'fgbcl.badges.placeholder.description' | translate }}</div>
    </div>
  </div>
  <div class="fgbcl-badges-card" *ngIf="categories.length > 0">
    <div class="fgbcl-badge-category" *ngFor="let category of categories; let last = last; let i = index" [class.mb-5]="!last">
      <div class="fgbcl-category-title">{{ category.Title }}</div>
      <div class="fgbcl-badges-grid">
        <button
          class="fgbcl-badge-card"
          type="button"
          *ngFor="let badge of getVisibleBadges(i, category.Badges); let bi = index"
          [ngClass]="getBadgeAnimClass(i, bi)"
          [class.fgbcl-badge-complete]="badge.Status === BadgeStatus.Completed"
          [class.fgbcl-badge-locked]="badge.Locked"
          (click)="openScorecard(badge)"
        >
          <div class="fgbcl-badge-image-wrapper">
            <img
              [src]="badge.Badge | contentImage: '6'"
              [alt]="badge.Name"
              class="fgbcl-badge-image"
              [class.fgbcl-badge-image-grayscale]="badge.Status !== BadgeStatus.Completed"
            />
            <span class="fgbcl-badge-count-pill" *ngIf="badge.NumberOfCompletions > 1">{{ badge.NumberOfCompletions }}</span>
          </div>
          <ng-container *ngIf="badge.Status === BadgeStatus.Completed; else incompleteLabel">
            <div class="fgbcl-badge-info">
              <p class="fgbcl-badge-name mb-0">{{ badge.Name }}</p>
              <p class="fgbcl-badge-date mb-0">{{ badge.CompletionDate | date: 'EEE, MMM d' }}</p>
            </div>
          </ng-container>
          <ng-template #incompleteLabel>
            <p class="fgbcl-badge-name mb-0">{{ badge.Name }}</p>
          </ng-template>
          <span class="material-icons fgbcl-badges-lock-icon" *ngIf="badge.Locked">lock</span>
        </button>
      </div>
      <button
        *ngIf="category.Badges.length > INITIAL_VISIBLE && !expandedCategories.has(i)"
        class="load-more-btn"
        type="button"
        (click)="loadMore(i)"
      >
        {{ 'fgbcl.load.more' | translate }}
      </button>
    </div>
  </div>
</div>
